import styled from "styled-components";

export const ModalConfirmationStyled = styled.div`
  .modal-confirmation {
    padding-bottom: 20px;
    &__row {
      > div {
        display: inline-block;
        &:nth-child(2) {
          margin: 0 5px;
        }
      }
    }
    &__buttons {
      margin-top: 20px;
    }
  }
`;
